import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import SearchButton from '../../../../../../shared/components/buttons/SearchButton';
import Filter from '../../../../../../shared/components/Filter';
import Wrapper from '../../../../../../shared/components/Wrapper';
import SetMonthEnd from './components/SetMonthEnd';
import SetMonthInitial from './components/SetMonthInitial';
import { reportClosed, reportUnifield } from './functions';

function AccountingFilter() {
  const dispatch = useDispatch();
  const [initial, setInitial] = useState('');
  const [end, setEnd] = useState('');
  const [fare] = useState('fiducia');
  return (
    <Filter.Default>
      <Wrapper.Default isActive flexDirection="row">
        <SetMonthInitial setDate={setInitial} date={initial} />
        <SetMonthEnd setDate={setEnd} date={end} />
      </Wrapper.Default>
      <SearchButton
        onClick={() => {
          reportUnifield(initial, end, fare, dispatch);
        }}
        justifyContent="center"
        width="10rem"
      />
    </Filter.Default>
  );
}

export function ClosedFilter() {
  const dispatch = useDispatch();
  const [initial, setInitial] = useState('');
  const [end, setEnd] = useState('');
  const [fare, setFareOption] = useState('fiducia');

  function setFare(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    setFareOption(value);
  }

  return (
    <Filter.Default>
      <Wrapper.Default isActive flexDirection="row">
        <SetMonthInitial setDate={setInitial} date={initial} />
        <SetMonthEnd setDate={setEnd} date={end} />
        <Wrapper.Default flexDirection="row" isActive>
          <span>Conta:</span>
          <Form.Control
            as="select"
            style={{ width: '10.5rem', margin: '0 0.5rem 0 0.25rem' }}
            value={fare}
            onChange={(event) => setFare(event)}>
            <option key={0} value="fiducia">
              {1} - Fidúcia
            </option>
            <option key={1} value="terceiros">
              {2} - Terceiros
            </option>
          </Form.Control>
        </Wrapper.Default>
      </Wrapper.Default>
      <SearchButton
        onClick={() => {
          reportClosed(initial, end, fare, dispatch);
        }}
        justifyContent="center"
        width="10rem"
      />
    </Filter.Default>
  );
}

export default AccountingFilter;
